import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { UTMEQuestions } from "@/builders/types/questions";

import { id } from "./id";

const get = function (params?: FilterParams) {
  return api.get<{
    count: number;
    next: string;
    previous: string;
    results: UTMEQuestions[];
  }>("/setup/questions", { params });
};

const post = function (data: UTMEQuestions) {
  return api.post("/setup/questions", data);
};

export const questions = {
  get,
  post,
  id,
};
